export const WhatsAppButton = () => (
  <a
    href="https://wa.me/919707788827?text=Hi%20Mehjabin%2C%20I%20found%20you%20through%20justbeyou.co.in%20%F0%9F%8C%99"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-btn"
    className="fixed bottom-6 left-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 px-4 py-3 hover:scale-105 transition-transform"
  >
    <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
      <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.6.8 5 2.3 7L4 29l7.3-2.3c1.9 1 4 1.6 6.2 1.6h.5c6.6 0 12-5.3 12-11.9C30 8.3 24.6 3 16 3zm6.7 16.9c-.3.8-1.6 1.5-2.3 1.6-.6.1-1.3.2-2.1-.1-.5-.2-1.1-.4-1.9-.7-3.4-1.5-5.6-4.9-5.8-5.1-.2-.2-1.4-1.8-1.4-3.5s.9-2.5 1.2-2.8c.3-.3.7-.4.9-.4h.7c.2 0 .5-.1.8.6.3.8 1.1 2.6 1.2 2.8.1.2.2.4 0 .7-.1.2-.2.4-.4.6l-.6.7c-.2.2-.4.4-.2.8.2.4 1 1.7 2.2 2.7 1.5 1.3 2.8 1.7 3.2 1.9.4.2.6.2.9-.1.2-.3 1-1.2 1.3-1.6.3-.4.5-.3.9-.2.4.1 2.4 1.1 2.8 1.3.4.2.7.3.8.5.1.2.1.9-.2 1.7z" />
    </svg>
    <span className="text-sm font-semibold hidden sm:inline">Chat with me</span>
  </a>
);
export default WhatsAppButton;
